<template>
  <el-dialog title="推币充值" :visible="visible" @close="onClose">
    <img :src="fail">
    <p class="title mt24">充值失败</p>
    <zt-wrap height="22px" class="link"></zt-wrap>
    
    <zt-wrap height="16px"></zt-wrap>
    <zt-button plain type="primary" size="medium" width="140px">遇到问题</zt-button>
    <zt-button class="ml20" type="primary" size="medium" width="140px" @click="onClose">重新充值</zt-button>
  </el-dialog>
</template>

<script>
import visibleMixins from './mixins/dialogVisible'
import imgMixins from './mixins/dialogImg'
export default {
  name: 'FailDialog',
  mixins: [ visibleMixins, imgMixins ],
}
</script>

<style lang="scss" scoped>
@import './styles/dialog.scss';
</style>